<template>
  <div>
    <div class="">
      <!-- <div class="cont"></div> -->
      <div class="user">
        <div style="position: relative; margin-bottom: 10px">
          <div class="fl">
            <a :href="'/useractivity?uid=' + publishUserId" target="_blank">
              <el-avatar :size="sizeList[1]" :src="circleUrl"></el-avatar>
              <span class="name">{{ article.userName }}</span>
            </a>
          </div>
          <div class="fl focus-btn">
            <el-button size="mini" v-if="me.follow_state == false" @click="clickFocusBtn(1)">+ 关注&nbsp;{{ followerNum
              }}</el-button>
            <div v-if="me.follow_state == true">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <el-button>已关注</el-button>
                  <!-- 已关注<i class="el-icon-arrow-down el-icon--right"></i> -->
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="clickFocusBtn(0)">取消关注</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
      <h3>{{ article.title }}</h3>
      <div class="readnum">
        {{ article.views }} 阅读 {{ likeNum }}点赞 {{ commentNum }}评论
      </div>
      <i class="el-icon-loading" v-show="showLoading"></i>
      <div class="ql-snow">
        <div class="text ql-editor" v-html="article.content">
        </div>
      </div>
      <div class="readnum">本文为我原创 本文禁止转载或摘编</div>
      <div class="likebtn-wrap">
        <a href="javascript:;" v-on:click="clickLikeBtn"><span v-if="me.like_state == true"
            class="icon iconfont icon-liked"></span><span v-if="me.like_state == false"
            class="icon iconfont icon-like"></span><a href="javascript:;" class="readnum2">{{ likeNum }}</a></a>
        <!-- <span class="icon iconfont icon-shoucang"></span>
        <span class="readnum2">222</span> -->
      </div>
      <CommentSlice :setCommentNum="setCommentNum" :publishUserId="publishUserId" :articleId="articleId"></CommentSlice>
    </div>
  </div>
</template>

<style>
@import "../assets/font_icon/iconfont.css";
@import "../assets/css/common.css";

.fl {
  float: left;
}

.fr {
  float: right;
}

.focus-btn {
  margin-left: 6px;
  padding-top: 4px;
}

/*大于等于980 */
@media screen and (min-width: 980px) {
  .cont-wrap {
    width: 980px;
    margin: 0 auto;
    background-color: white;
    padding: 16px;
    margin-top: 16px;
  }
}

@media screen and (max-width: 980px) {
  .cont-wrap {
    width: 90%;
    margin: 0 auto;
    background-color: white;
    padding: 16px;
    margin-top: 16px;
  }
}

.el-avatar {
  vertical-align: middle;
}

.name {
  margin-left: 8px;
}

.focusbtn {
  margin-left: 8px;
}

.readnum {
  color: #9b9b9b;
  font-size: 14px;
  padding: 8px 16px 16px 0px;
}

.readnum2 {
  color: #9b9b9b;
  font-size: 14px;
  margin-left: 4px;
  margin-right: 8px;
}

.text {
}

.comment-num {
  padding: 16px 16px 16px 0px;
}

.replybtns {
  margin-top: 16px;
  float: right;
}

.comment {
  background-color: #ffffff;
  text-align: left;
  padding: 16px 32px;
}

.comm-cont {
  border-bottom: #e2e2e2 1px solid;
  margin-top: 32px;
  position: relative;
  padding-bottom: 32px;
}

.avatar {
  display: inline-block;
  position: absolute;
  left: 0;
}

.avatar {
  vertical-align: middle;
  padding-top: 8px;
}

.comm-detail {
  margin-left: 60px;
}

.date,
.date a {
  color: #999;
  font-size: 14px;
}

.date a {
  margin-left: 16px;
}

.name {
  color: #757575;
  font-size: 14px;
}

.mr-10 {
  margin-right: 10px;
}

.ml-20 {
  margin-left: 20px;
}

.cont {
  padding: 16px 0 16px 0;
}

.comm-num {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}

.see-comm {
  color: #00a1d6;
  margin-left: 16px;
  font-size: 14px;
}

a:hover {
  color: #00a1d6;
}

.ava-check {
  float: left;
  padding: 8px;
  padding-right: 16px;
}

.replyarea {
  display: none;
  margin-top: 16px;
}

h3 {
  margin-bottom: 3px;
}

.ql-editor{padding:0px;}
 .likebtn-wrap{padding-bottom:8px;}
</style>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import 'highlight.js/styles/dark.css';
import CommentSlice from "../component-slice/comment_slice.vue";

export default {
  components: {
    CommentSlice,
  },
  props:["id"],
  data() {
    return {
      // 圆形图片的URL
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      // 正方形图片的URL
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      // 尺寸列表
      sizeList: ["large", "medium", "small"],
      // 文章对象
      article: { title: "", content: "" },
      // 发布文章的用户ID
      publishUserId: 0,
      // 登录用户的ID
      loginuid: 0,
      // 文章ID
      articleId: 0,
      // 关注者数量
      followerNum: 0,
      // 点赞数
      likeNum: 0,
      // 评论数
      commentNum: 0,
      me: { like_state: false }, //内容发布者的个人信息，不是登录者的
      // 内容发布者的个人信息，不是登录者的
      showLoading: true,  //正在加载中...
    };
  },

  mounted() {
    this.showLoading = true;
    var _uid = localStorage.getItem("loginuid");
    this.loginuid = _uid == null || _uid == undefined ? 0 : parseInt(_uid);
    //var id = this.$route.params.id;
    this.articleId = this.id;
    this.getArticle(this.id);
    this.getLikeCount();
  },
  methods: {
    setCommentNum(commNum) {
      this.commentNum = commNum;
    },
    getMeState() {
      //获取登录用户相关的关注及点赞状态
      if (this.loginuid == 0) return; //未登录状态
      this.$http
        .get("/api/me/" + this.publishUserId + "/" + this.articleId)
        .then((r) => {
          console.log(r);
          this.me = r.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getArticle(id) {
      this.$http
        .get("/api/articleview/" + id)
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200 && r.data.data != null) {
            this.article = r.data.data;
            this.publishUserId = this.article.uid;
            //获取关注的人数
            this.getFollowerCount();
          }
          this.showLoading = false;
          this.getMeState();
        })
        .catch((e) => {
          this.showLoading = false;
          console.log(e);
        });
    },
    getFollowerCount() {
      this.$http
        .get("/api/Follower/" + this.publishUserId)
        .then((r) => {
          console.log(r);
          var count = r.data;
          if (count > 10000) {
            count = count / 10000.0;
          }
          this.followerNum = count;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getLikeCount() {
      this.$http
        .get("/api/like/" + this.articleId)
        .then((r) => {
          console.log(r);
          this.likeNum = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clickFocusBtn(cancelOrFollow) {
      //点击关注
      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$http
        .post("/api/follower/", {
          follwer_uid: this.publishUserId,
          opt: cancelOrFollow,
        })
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data == 0) {
            var strTip = "取消关注成功";
            if (cancelOrFollow == 1) {
              strTip = "关注成功";
              this.followerNum += 1;
              this.me.follow_state = true;
            } else {
              this.followerNum -= 1;
              this.me.follow_state = false;
            }
            this.$alert(strTip, "", {
              confirmButtonText: "确定",
            });
          } else {
            var strTip2 = "取消关注失败,请重试";
            if (cancelOrFollow == 1) {
              strTip2 = "关注失败,请重试";
            }
            this.$alert(strTip2, "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clickLikeBtn() {
      //点赞功能
      if (this.loginuid == 0) {
        //未登录
        this.$alert("请先登录", "", {
          confirmButtonText: "确定",
        });
        return;
      }
      let _this = this;
      this.$http
        .post("/api/like/", {
          cont_id: parseInt(this.articleId),
          uid: this.loginuid,
          beuid: this.uid,
        })
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            if (_this.me.like_state == true) {
              //现在是取消点赞
              _this.me.like_state = false;
              _this.likeNum -= 1;
            } else {
              _this.me.like_state = true;
              _this.likeNum += 1;
            }
            this.$alert(r.data.msg, "", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("操作失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>